import React, { useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';

import UserPool from "../UserPool";
import { CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js';
import { useNavigate } from 'react-router-dom';
import ItemListStory from '../components/ItemListStory';

import HeaderLogin from '../components/HeaderLogin';
import { Footer } from '../components/FooterLogin';

const Dashboar = () => {

    return (
          <div className="app">
            <HeaderLogin/>            
              <ItemListStory />
            <Footer/>
          </div>
    );
};

export default Dashboar;
